import { DocumentType } from '@synergy/models';

import { ConverterJob } from '../models/internal/converterJob';
import { ConverterPositionItem } from '../models/internal/converter-positionItem';
import { SalesOrder } from '../../sales-orders/models/salesOrder';
import { TransitionTarget } from '../models/internal/transition-target';

export const createConverterJobFromSalesOrder = (salesOrder: SalesOrder): ConverterJob | undefined => {
    if (!salesOrder.customerAccount) {
        return undefined;
    }

    const customer = salesOrder.customerAccount;
    const source: ConverterJob = {
        source: salesOrder,
        possibleTargets: [TransitionTarget.PurchaseOrder, TransitionTarget.Inquiry],
        selectedTarget: salesOrder.generatesPurchaseOrder ? TransitionTarget.PurchaseOrder : TransitionTarget.Inquiry,
        selectedCustomerId: -1,
        documentType: DocumentType.SalesOrder,
        supportsDeliveryCosts: true,
        hasDeliveryDate: false,
        customers: salesOrder.positions.map(position => ({
            id: position.id || -1,
            name: customer.name,
            isLocked: customer.isLocked,
            deliveryAddress: position.deliveryAddress,

            customerSuppliers: [
                {
                    id: position.deliveryAddress.id,
                    name: '',
                    deliveryPrice: 0,
                    surcharge: 0,
                    items: position.items.map(ConverterPositionItem.fromPlainObject),
                },
            ],
        })),
    };
    return ConverterJob.fromPlainObject(source);
};
